import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from "axios";
import { COMPANY_URLS } from "./Utils/Company_App_Urls";
import { URLS } from "./Utils/App_urls";
// import { api } from "./Utils/ApiUrls";
// import API_URLs from './src/Utils/App_urls'
// const vapidKey = 'BK-MB_3750mL1MpMNHp44OBkl40Nc43RwiTqlHb2CMTPGmopkSamK2jABUj7fkVKwg7K163g3y-8vfyMS1dnxZA'
const vapidKey = 'BCctI6ugkLGVqjUmroghYHrcKYP_vMBY-DZL1ykTbXibgLsFuSaxZhu6RVTAsBSp0ocXcvfRVdsBwJzQxKYMna8'

const firebaseConfig = {
    apiKey: "AIzaSyDOPN_ZHU8k4eT6aODdwYienEgMYZeFhQo",
    authDomain: "kaamvala-cc55d.firebaseapp.com",
    projectId: "kaamvala-cc55d",
    storageBucket: "kaamvala-cc55d.firebasestorage.app",
    messagingSenderId: "546831282048",
    appId: "1:546831282048:web:ea0b823fcc0f297699db65",
    measurementId: "G-CG17MGMGRM"
};

// Initialize Firebase
export const requestForToken = async () => {
    const app = await initializeApp(firebaseConfig);
    const messaging = getMessaging(app);
    const analytics = getAnalytics(app);

    const sendFcmToken = (fcmTokenpara) => {
        const fcmToken = { "fcmDeviceToken": fcmTokenpara }
        axios.post(`${COMPANY_URLS.saveFcmToken}`, fcmToken, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then((res) => { })
            .catch((err) => { })
    }

    return getToken(messaging, { vapidKey: vapidKey })
        .then((currentToken) => {
            if (currentToken) {
                localStorage.setItem('fcmToken', currentToken)
                sendFcmToken(currentToken)
                return currentToken
            }
        })
        .catch((err) => { console.error(err) });
};

export const requestTokenForUser = async () => {
    const app = await initializeApp(firebaseConfig);
    const messaging = getMessaging(app);
    const analytics = getAnalytics(app);

    const sendFcmToken = (fcmTokenpara) => {
        const fcmToken = { "fcmDeviceToken": fcmTokenpara }
        axios.post(`${URLS.saveFcmTokenUser}`, fcmToken, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then((res) => { })
            .catch((err) => { })
    }

    return getToken(messaging, { vapidKey: vapidKey })
        .then((currentToken) => {
            if (currentToken) {
                localStorage.setItem('fcmToken', currentToken)
                sendFcmToken(currentToken)
                return currentToken
            }
        })
        .catch((err) => { console.error(err) });
};